require("../app/history-page.coffee")

window.pageInitFlag = false
pageInit = ->
  new window.HistoryPage()

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/history.coffee